<template>
  <div class="schedule-wrapper">
    <div class="month-name">{{monthName | capitalize}}</div>
    <div class="week-names-wrapper">
      <div
        v-for="(w, i) in Array(7)"
        :key="'w-'+i"
        class="flx-14 week-name mb-10"
      >{{ getWeekName(i) }}</div>
    </div>
    <div class="schedule">
      <div v-for="(day, i) in Array(35)" :key="'d-'+i" class="flx-14">
        <!-- <MonthDay
          v-if="getDay(i) < firstDayOfWeek || getDay(i) > days"
          :schedule="getDayScheduleNextMonth(i)"
          :reservations="getDayReservationsNextMonth(i)"
          :dayNumber="calculateDay(i)"
          :weekDay="getWeekDayNextMonth(i)"
          :disabled="getDay(i) < firstDayOfWeek"
        /> -->
        <MonthDay
          v-if="getDay(i) < firstDayOfWeek || getDay(i) > days"
          :schedule="getDayScheduleNextMonth(i)"
          :reservations="getDayReservationsNextMonth(i)"
          :dayNumber="calculateDay(i)"
          :weekDay="getWeekDayNextMonth(i)"
          :disabled="false"
          :services="services"
          :specialist="specialist"
          :company="company"
        />

        <!-- <MonthDay
          v-else
          :schedule="getDaySchedule(i)"
          :reservations="getDayReservations(i)"
          :dayNumber="calculateDay(i)"
          :weekDay="getWeekDay(i)"
          :disabled="isPrevDay(i)"
        /> -->
        <MonthDay
          v-else
          :schedule="getDaySchedule(i)"
          :reservations="getDayReservations(i)"
          :dayNumber="calculateDay(i)"
          :weekDay="getWeekDay(i)"
          :disabled="false"
          :services="services"
          :specialist="specialist"
          :company="company"
        />
      </div>
    </div>
  </div>
</template>
    
<script>
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { mapActions, mapState } from "vuex";
import moment from "moment";
import { MonthDay } from "@/components/Scheduler";
import { MONTH_TYPES, WEEKS } from "@/components/Scheduler/modules/constants";
import {
  daysInMonth,
  calculateFirstWeekDayOfMonth,
  getDay,
  getDay2Digit,
  getMonth2Digit,
  calculateWeekDayOfMonth
} from "@/components/Scheduler/modules/helpers";

@Component({
  components: {
    MonthDay
  },
  methods: mapActions(["getScheduleByMonth", "getReservationsByMonth"]),
  computed: mapState([
    "schedule",
    "prevMonthSchedule",
    "nextMonthSchedule",
    "reservations",
    "prevMonthReservations",
    "nextMonthReservations"
  ]),
  filters: {
    capitalize(value) {
      return value.charAt(0).toUpperCase() + value.substring(1);
    }
  }
})
export default class Month extends Vue {
  @Prop() date;
  @Prop() spec_slug;
  @Prop() services
  @Prop() specialist
  @Prop() company
  year = 0;
  choosenMonth = 0;
  weeks = WEEKS;
  days = 0;
  prevMonthDays = 0;
  firstDayOfWeek = 0;

  @Watch("date", { deep: true, immediate: true })
  onDateChange() {
    this.choosenMonth = this.date.getMonth() + 1;
    this.year = this.date.getFullYear();
    this.days = daysInMonth(this.choosenMonth, this.year);
    this.prevMonthDays = daysInMonth(this.choosenMonth - 1, this.year);
    this.firstDayOfWeek = calculateWeekDayOfMonth(
      1,
      this.choosenMonth,
      this.year
    );

    this.getDataFromApi();
  }

  @Watch("spec_slug", { deep: true, immediate: true })
  onSpecChange() {
    this.choosenMonth = this.date.getMonth() + 1;
    this.year = this.date.getFullYear();
    this.days = daysInMonth(this.choosenMonth, this.year);
    this.prevMonthDays = daysInMonth(this.choosenMonth - 1, this.year);
    this.firstDayOfWeek = calculateWeekDayOfMonth(
      1,
      this.choosenMonth,
      this.year
    );

    this.getDataFromApi();
  }

  get monthName() {
    return moment(this.date).format("MMMM");
  }

  // Получение номера дня по индексу
  getDay(i) {
    return getDay(i);
  }

  // Определить номер дня в текущем месяце по индексу
  getDayInCurrentMonth(i) {
    const currentDay = getDay(i);
    return currentDay - this.firstDayOfWeek + 1;
  }
  //i = 1, dayWeek = 6, daysMonth 29 ,return 25 29 - 6 + 1 + 1 = 25 true
  //i=2, return 24 29 - 6 + 2 + 1 =

  // получить объект расписания на день по индексу
  getDaySchedule(i) {
    const dayInCurrentMonth = this.getDayInCurrentMonth(i);
    const daySchedule = this.schedule[dayInCurrentMonth - 1];
    return daySchedule;
  }

  getDayScheduleNextMonth(i) {
    const nextMonthDay = this.calculateDay(i);
    if (nextMonthDay > 15) {
      return this.prevMonthSchedule[nextMonthDay - 1];
    }
    const daySchedule = this.nextMonthSchedule[nextMonthDay - 1];
    return daySchedule;
  }

  getDayReservations(i) {
    const dayInCurrentMonth = this.getDayInCurrentMonth(i);
    const day = getDay2Digit(dayInCurrentMonth);
    const month = getMonth2Digit(this.choosenMonth);
    const searchDate = `${day}.${month}.${this.year}`;
    const reservations = this.reservations.filter(reservation =>
      reservation.date_time_reservation.includes(searchDate)
    );
    return reservations;
  }

  getDayReservationsNextMonth(i) {
    const nextMonthDay = this.calculateDay(i);
    let month;
    let source;
    const day = getDay2Digit(nextMonthDay);
    if (nextMonthDay > 15) {
      month = getMonth2Digit(this.choosenMonth - 1);
      source = this.prevMonthReservations;
    } else {
      month = getMonth2Digit(this.choosenMonth + 1);
      source = this.nextMonthReservations;
    }
    const searchDate = `${day}.${month}.${this.year}`;
    const reservations = source.filter(reservation =>
      reservation.date_time_reservation.includes(searchDate)
    );
    return reservations;
  }

  // заголовок для выходного дня
  getDayTitle(i) {
    const daySchedule = this.getDaySchedule(i);
    return daySchedule.periods.length ? "Work" : "Выходной";
  }

  // получить тип дня по индексу
  getDayType(i) {
    const daySchedule = this.getDaySchedule(i);
    return daySchedule.periods.length ? "free" : "holiday";
  }

  getWeekDay(i) {
    const dayInCurrentMonth = this.getDayInCurrentMonth(i);
    const weekDay = calculateWeekDayOfMonth(
      dayInCurrentMonth,
      this.choosenMonth,
      this.year
    );
    return weekDay;
  }
  getWeekDayNextMonth(i) {
    const nextMonthDay = this.calculateDay(i);
    let weekDay;

    if (nextMonthDay > 7) {
      weekDay = calculateWeekDayOfMonth(
        nextMonthDay,
        this.choosenMonth - 1,
        this.year
      );
    } else {
      weekDay = calculateWeekDayOfMonth(
        nextMonthDay,
        this.choosenMonth + 1,
        this.year
      );
    }
    return weekDay;
  }

  getWeekName(i) {
    return WEEKS[i + 1].short;
  }

  calculateDay(index) {
    const currentDay = getDay(index);
    const dayInCurrentMonth = this.getDayInCurrentMonth(index);
    if (currentDay < this.firstDayOfWeek) {
      //prev month
      return this.prevMonthDays - this.firstDayOfWeek + currentDay + 1;
    } else if (currentDay > this.days && dayInCurrentMonth > this.days) {
      //next month
      return currentDay - this.days - this.firstDayOfWeek + 1;
    } else {
      return dayInCurrentMonth;
    }
  }

  isPrevDay(i) {
    const dayInCurrentMonth = this.getDayInCurrentMonth(i);
    const today = new Date().getDate();
    const currentMonth = new Date().getMonth() + 1;
    if (currentMonth > this.choosenMonth) return true;
    return today > dayInCurrentMonth;
  }

  created() {
    this.choosenMonth = this.date.getMonth() + 1;
    this.year = this.date.getFullYear();
    this.days = daysInMonth(this.choosenMonth, this.year);
    this.prevMonthDays = daysInMonth(this.choosenMonth - 1, this.year);
    this.firstDayOfWeek = calculateWeekDayOfMonth(
      1,
      this.choosenMonth,
      this.year
    );
  }

  async getDataFromApi() {
    const nextMonthDays = daysInMonth(this.choosenMonth + 1, this.year);
    const prevMonthDays = daysInMonth(this.choosenMonth - 1, this.year);
    await this.getScheduleByMonth({
      month: this.choosenMonth,
      year: this.year,
      spec_slug: this.spec_slug,
      daysInMonth: this.days,
      monthType: MONTH_TYPES.CURRENT
    });
    await this.getScheduleByMonth({
      month: this.choosenMonth - 1,
      year: this.year,
      spec_slug: this.spec_slug,
      daysInMonth: prevMonthDays,
      monthType: MONTH_TYPES.PREV
    });
    await this.getScheduleByMonth({
      month: this.choosenMonth + 1,
      year: this.year,
      spec_slug: this.spec_slug,
      daysInMonth: nextMonthDays,
      monthType: MONTH_TYPES.NEXT
    });
    await this.getReservationsByMonth({
      month: this.choosenMonth,
      year: this.year,
      spec_slug: this.spec_slug,
      monthType: MONTH_TYPES.CURRENT
    });
    await this.getReservationsByMonth({
      month: this.choosenMonth - 1,
      year: this.year,
      spec_slug: this.spec_slug,
      monthType: MONTH_TYPES.PREV
    });
    await this.getReservationsByMonth({
      month: this.choosenMonth + 1,
      year: this.year,
      spec_slug: this.spec_slug,
      monthType: MONTH_TYPES.NEXT
    });
  }

  async mounted() {
    this.getDataFromApi();
  }
}
</script>

<style lang="stylus" scoped>
@import '../../../styles/main.core.vars.styl';

.schedule-wrapper {
  .week-names-wrapper {
    display: flex;
  }

  .month-name {
    font-family: Didact Gothic;
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 31px;
    color: #333333;
  }

  .schedule {
    display: flex;
    flex-wrap: wrap;
  }

  .week-name {
    text-align: center;
    font-family: Montserrat;
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 16px;
    color: #333333;
  }
}
</style>